import React from 'react';
import PropTypes from 'prop-types';

import CheckmarkIcon from '../../../../../../../../components/icons/CheckmarkIcon';

const propTypes = {
  features: PropTypes.arrayOf(PropTypes.string),
};

const FreemiumEventLandingPageFeatureList = ({ features }) => {
  return (
    <div className="checked-icon-list flex-none text-bold">
      <ul>
        {features.map((feature, index) => {
          return (
            <li key={index} className="text-dark text-bold">
              <CheckmarkIcon
                color="#0d84fe"
                size="14px"
                className="feature-icon"
              />
              <span>{feature}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

FreemiumEventLandingPageFeatureList.propTypes = propTypes;

export default FreemiumEventLandingPageFeatureList;
